export const MODULE_KEY_CHECKOUT = 'checkoutSideReview';
export const GLASSES_CARE_SKU = 'insurance_20_20_recurring';
